"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTestMode = exports.loadTestMode = exports.testMode = exports.isDevMode = exports.test_freeJumps = exports.skipVersionCheck = exports.singleplayerAutoJoin = exports.multiplayerAutoJoin = exports.disableDirector = exports.useRemoteMultiplayer = exports.isLocal = exports.version = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var localStorer_sidecar_1 = require("@lib/localStorer-sidecar");
exports.version = '0.1.1-kft';
exports.isLocal = window.location.href.includes('localhost:') ||
    window.location.href.includes('http://192.168.');
// export const experimentalMultiplayer = true
exports.useRemoteMultiplayer = false; // !isLocal || true
exports.disableDirector = false;
exports.multiplayerAutoJoin = true;
exports.singleplayerAutoJoin = false;
exports.skipVersionCheck = exports.isLocal;
exports.test_freeJumps = false && exports.isLocal;
exports.isDevMode = true && exports.isLocal;
var settingKey = '_voyage_testmode';
exports.testMode = 'normal';
var loadTestMode = function () {
    websockets_sidecar_1.websockets.setMultiplayerAutoJoin(exports.multiplayerAutoJoin);
    websockets_sidecar_1.websockets.setUseRemoteMultiplayer(exports.useRemoteMultiplayer);
    websockets_sidecar_1.websockets.setSkipVersionCheck(exports.skipVersionCheck);
    exports.testMode = localStorer_sidecar_1.localStorer.load(settingKey, 1) || 'normal';
    return exports.testMode;
};
exports.loadTestMode = loadTestMode;
var setTestMode = function (tm) {
    localStorer_sidecar_1.localStorer.save(settingKey, 1, tm);
    window.location.reload();
};
exports.setTestMode = setTestMode;
// export let skipRequireTech = true
// export let doTestGraphics = false
// export let testParticles = false
// export let testSpeedMult = 1
// export let testDealParts: boolean = false
// export let autoFullTest: boolean = false
// export let autoBuild: boolean = false || autoFullTest
// export let autoLoadCargo: boolean = (false || autoFullTest) && autoBuild
// export let autoLoadAstronauts: boolean = (false || autoFullTest) && autoBuild
// export let autoLaunch: boolean = (false || autoFullTest) && autoBuild
// export let autoChoosePath: boolean = (false || autoFullTest) && autoBuild
// export let autoFight: boolean = (false || autoFullTest) && autoBuild
// export let autoEndMission: boolean = (false || autoFullTest) && autoBuild
// export let autoSelectMission: boolean = (false || autoFullTest) && autoBuild
// export let shipClass: goatShipClassData.GoatShipClassType = 'c4'
